import { createSlice } from "@reduxjs/toolkit"

const orderSlice = createSlice({
    name: "orders",
    initialState: {
        orders: [],
        isFetching: false,
        error: null
    },
    reducers: {
        orderStart: (state) => {
            state.isFetching = true
        },
        orderFailure: (state, action) => {
            state.orders = []
            state.isFetching = false
            state.error = action.payload
        },
        getOrderSuccess: (state, action) => {
            state.orders = action.payload
            state.isFetching = false
            state.error = null
        },
        createOrderSuccess: (state, action) => {
            state.orders.push(action.payload)
            state.isFetching = false
            state.error = null
        }
    }
})

export const { orderStart, orderFailure, getOrderSuccess, createOrderSuccess } = orderSlice.actions
export default orderSlice.reducer